export default theme => ({
  iconButton: {
    padding: 9,
  },
  tooltipContainer: {
    display: "inline-block",
  },
  actionButton: {
    marginTop: "0px !important",
  },
  dialog: {
    width: "100%",
  },
});
